import React from 'react';
import { Check } from 'lucide-react';
import { evaluatePasswordRules, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '../../utils/passwordRules';

type Props = {
  password: string;
  className?: string;
};

const PasswordRequirementsList: React.FC<Props> = ({ password, className }) => {
  const s = evaluatePasswordRules(password);
  const items: { ok: boolean; label: string }[] = [
    { ok: s.minLength, label: `Al menos ${PASSWORD_MIN_LENGTH} caracteres` },
    { ok: s.hasLetter, label: 'Incluye letras' },
    { ok: s.hasDigit, label: 'Incluye números' },
    { ok: s.hasSpecial, label: 'Incluye un carácter especial' },
    { ok: s.noDisallowedChars, label: 'Sin caracteres de control ni invisibles' },
    { ok: s.withinMaxLength, label: `Máximo ${PASSWORD_MAX_LENGTH} caracteres` },
  ];

  return (
    <ul className={`password-rules-list ${className ?? ''}`.trim()} aria-live="polite">
      {items.map((row) => (
        <li
          key={row.label}
          className={`password-rules-item ${row.ok ? 'password-rules-item--ok' : ''}`.trim()}
        >
          <span className="password-rules-check" aria-hidden>
            {row.ok ? <Check size={14} strokeWidth={3} /> : ''}
          </span>
          <span>{row.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirementsList;
